<template>
    <div class="contact-page">
        <div class="img">
            <img src="../assets/contact_bg.png" />
        </div>

        <div class="desc" v-if="lang=='fr'">
            <h1>Contact</h1>
            <p>
                Pour commander les gants d’Amélie et les régler

                par chèque ou par virement bancaire,

                merci de nous contacter soit :
                <ul>
                    <li>par mail : <a href="mailto:contact@lesgantsdamelie.com">contact@lesgantsdamelie.com</a></li>
                    <li>par téléphone au <a href="tel:+33142880011">0033 (0)1 42 88 00 11</a></li>
                    <li>par courrier : 9 rue de la Tour, 75116 Paris</li>
                </ul>

                <a class="focus" href="../../static/pdf/web/lesgantsdamelie_bdc.pdf" target="_blank">Cliquez ici pour télécharger et imprimer le bon de commande et les conditions de vente.</a> (PDF)
            </p>
            <p>
            Les gants d’Amélie sont également en vente

            dans le point de vente suivant :
                <br />
                - <a href="http://www.golfdemorfontaine.fr/" target="_blank">Golf de Mortfontaine</a><br />
                60128 Mortefontaine - Tel : 03 44 54 68 27
            </p>
            <p>
            ( les tarifs pratiqués sont indépendants

            de ceux de notre site )
            </p>
        <p>
            Vous pouvez également visiter notre site : <br/><a href="http://www.aim-production.com" target="_blank">http://www.aim-production.com</a>
        </p>
        <p>
            <strong>AIM - LES GANTS D'AMELIE</strong><br />
            9, rue de la Tour<br />
            75116 Paris
        </p>
        </div>

        <div class="desc" v-if="lang=='en'">
            <h1>Contact</h1>
            <p>
                To place an order and proceed to payment

                by check (in Euro drawn on a bank in France) or money order,

                please contact us either:

                <ul>
                    <li>by email, just <a href="mailto:contact@lesgantsdamelie.com">Click here</a></li>
                    <li>by phone, dial <a href="tel:+33142880011">0033 (0)1 42 88 00 11</a></li>
                    <li>by fax, dial 0033 (0)1 45 25 68 49</li>


                </ul>
                <a class="focus" href="../../static/pdf/web/lesgantsdamelie_bdc.pdf" target="_blank">Click here to download our Order Form and Terms & Conditions.</a> (PDF)
            </p>
            <p>
                Amelie’s gloves are also available

                at the following retail store:

                <br/>
                - <a href="http://www.golfdemorfontaine.fr/" target="_blank">Golf de Mortfontaine</a><br />
                60128 Mortefontaine - Tel : 03 44 54 68 27
            </p>
            <p>
                (Prices at retail stores are independent of our policy.)
            </p>
            <p>
                Don't forget to check out Amelie's Film and Music Production Company : <br />
                <a href="http://www.aim-production.com" target="_blank">http://www.aim-production.com</a>
            </p>
            <p>
                <strong>AIM - LES GANTS D'AMELIE</strong><br />
                9, rue de la Tour<br />
                75116 Paris
            </p>
        </div>


    </div>

</template>

<script>
  import FlickityBox from './FlickityBox';

  export default {

    components: {
      FlickityBox,
    },
    props: ['lang'],
    methods: {
    },
  };
</script>
<style lang="scss">
    .contact-page {
        display: flex;
        animation: fadeIn 1s;

        align-items: stretch;
        @media screen and (max-width:768px){
            flex-direction: column;
        }

        .img, .desc {
            flex: 50% 0;
        }

        strong {color: #9c554b;}
        @media screen and (max-width:768px) {
            .img {
                text-align: center;
            }
            .desc {margin:auto;}
        }
        @media screen and (min-width:768px) {
            .desc {
                margin-top:5rem;
            }
            .img {
                text-align: right;
                margin-right: 1rem;
                margin-top: 5rem;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/ContactPage.vue